import { makeExecutableSchema } from 'graphql-tools';
import { typeDefs } from './typeDefs';
import { resolvers } from './resolvers';

const mockSchema = makeExecutableSchema({
    typeDefs: [typeDefs],
    resolvers,
});

export default mockSchema;